export const formatMmValue = (value: any) => {
  const numberValue = Number(value);
  if (!Number.isFinite(numberValue)) return '';

  return Number.isInteger(numberValue) ? String(numberValue) : numberValue.toFixed(2).replace(/\.?0+$/, '');
};

export const hasThicknessValue = (value: any) =>
  value !== undefined && value !== null && value !== '' && formatMmValue(value) !== '';

export const formatThicknessBadge = (thickness: any) => {
  if (!hasThicknessValue(thickness)) return '';

  return `厚さ設定値 ${formatMmValue(thickness)}mm`;
};

export const PartThicknessBadge = ({ thickness }: { thickness: any }) => {
  if (!hasThicknessValue(thickness)) return null;

  return (
    <div className="mt-2 flex w-full flex-wrap justify-center gap-1">
      <span className="whitespace-nowrap rounded-full border border-[#d8dfef] bg-white/95 px-4 py-[6px] text-[16px] leading-[24px] font-medium text-[#515c6f] shadow-sm">
        {formatThicknessBadge(thickness)}
      </span>
    </div>
  );
};
